import React from "react";
import { cn } from "@/lib/utils";

interface DesktopMockupProps {
    children?: React.ReactNode;
    imageSrc?: string;
    className?: string;
}

export const DesktopMockup = ({ children, imageSrc, className }: DesktopMockupProps) => {
    return (
        <div className={cn("relative w-[480px] max-w-full", className)}
             style={{ backfaceVisibility: "hidden", WebkitBackfaceVisibility: "hidden" }}>
            
            {/* Main Screen Body */}
            <div className="relative rounded-[0.9rem] bg-gradient-to-b from-neutral-600 to-neutral-800 p-[2px] shadow-[0_40px_80px_-20px_rgba(0,0,0,0.75)] ring-1 ring-white/10">
                <div className="relative aspect-[16/10] w-full overflow-hidden rounded-[0.7rem] bg-black p-[4px]">
                    {/* Camera Notch - Tiny pill */}
                    <div className="absolute left-1/2 top-0 z-30 h-[12px] w-[60px] -translate-x-1/2 rounded-b-lg bg-black flex items-center justify-center">
                        <div className="w-1 h-1 rounded-full bg-blue-500/30" />
                    </div>

                    {/* Screen Content */}
                    <div className="relative h-full w-full overflow-hidden rounded-[0.4rem] bg-[#0a0a14]">
                        {/* Subtle screen highlight */}
                        <div className="absolute inset-0 z-10 pointer-events-none bg-gradient-to-br from-white/5 to-transparent" />
                        
                        {imageSrc ? (
                            <img 
                                src={imageSrc} 
                                alt="Desktop screen" 
                                className="h-full w-full object-cover"
                                loading="lazy"
                            />
                        ) : (
                            children
                        )}
                    </div>
                </div>
            </div>

            {/* Chin below screen - Trapezoidal */}
            <div className="relative mx-auto -mt-[1px] w-[96%] h-6 bg-gradient-to-b from-neutral-700 to-neutral-900 border-t border-white/5"
                 style={{ clipPath: "polygon(2% 0, 98% 0, 100% 100%, 0 100%)" }}>
                {/* Visual placeholder for logo/accent */}
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 rounded-full bg-white/5" />
            </div>

            {/* Keyboard Deck - Protruding */}
            <div className="relative mx-auto -mt-[2px] flex justify-center">
                <div className="h-8 w-[118%] rounded-b-2xl bg-gradient-to-b from-neutral-600 to-neutral-900 shadow-[0_12px_40px_rgba(0,0,0,0.8)] ring-1 ring-black/40 overflow-hidden">
                    {/* Hinted keycaps - horizontal stripes */}
                    <div className="absolute inset-0 opacity-10 bg-[linear-gradient(90deg,transparent_0%,rgba(0,0,0,0.5)_50%,transparent_100%)] bg-[length:40px_100%]" />
                    {/* Trackpad notch */}
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-[3px] rounded-b-full bg-black/60" />
                </div>
            </div>
        </div>
    );
};

export default DesktopMockup;
